/**
 * GA4 tracking utilities.
 *
 * Events are sent via window.gtag, which is set up by Google Tag Manager
 * (loaded in index.html). Do NOT use react-ga4's GA.initialize() alongside
 * GTM — it loads a second gtag.js script that overwrites window.gtag and
 * causes events to be lost.
 */

const isProduction = window.location.hostname === "app.surmount.ai";

const gtag = (...args) => {
  if (!isProduction) {
    console.log("[GA4]", ...args);
  }
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

export const trackEvent = ({ name, label, value, ...rest }) => {
  const eventName = name || "click";
  gtag("event", eventName, {
    label: label || document.title,
    ...(value !== undefined && { value }),
    ...rest,
  });
};

export const trackPage = (params) => {
  gtag("event", "page_view", {
    page_title: document.title,
    ...params,
  });
};

export const setTrackingUserId = (userId) => {
  gtag("set", { user_id: userId });
};
